import { CropText } from '../collapsable/collapsable';
import { DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';

export function Description({
  title,
  description,
  needCrop = false,
}: {
  title?: string;
  description: string;
  needCrop?: boolean;
}) {
  return (
    <>
      {title && (
        <div
          css={{
            fontFamily: 'Montserrat',
            fontSize: 13,
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '16px',
            letterSpacing: '0.04em',
            color: '#f44336',
            textTransform: 'uppercase',
            marginBottom: 10,
          }}
        >
          {title}
        </div>
      )}
      <div
        css={{
          color: '#000',
          h1: {
            fontSize: 48,
          },
          h2: {
            fontSize: 21,
          },
          h3: {
            fontSize: 16,
          },
          'h1, h2, h3, h4': {
            margin: '16px 0',
            fontWeight: 700,
          },
          hr: {
            borderTop: '1px solid #000',
          },
          img: {
            maxWidth: '100%',
            width: 'auto',
            display: 'inline',
          },
          ol: {
            listStyleType: 'decimal',
            listStylePosition: 'outside',
            marginLeft: 8,
            paddingLeft: 8,
            li: {
              display: 'list-item',
            },
          },
          a: {
            color: '#f44336',
            transform: 'none',
          },
          table: {
            border: '1px solid',
            borderCollapse: 'separate',
            borderSpacing: '1px',
            width: 'auto !important',
            boxSizing: 'border-box',
          },
          td: {
            border: '1px solid',
            verticalAlign: 'middle',
            padding: '0 2px',
          },
          [DEVICE_SCREENS_MAX_STRING.md]: {
            h1: {
              fontSize: 24,
            },
          },
        }}
      >
        {needCrop ? (
          <CropText text={description} deskTopCount={1000} mobileCount={1000} />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: description }} />
        )}
      </div>
    </>
  );
}
